<template>
<div class="popup" v-cloak v-show="retryFailedShow">
    <div class="content" id="retryFailed">
        <div class="title">
            {{$t('language.common.failedFiles')}}
            <div class="icon white-close dialog-close" @click.stop="closePage()"></div>
        </div>
        <div class="retry-body">
            <div class="retry-buttons" v-if="transferType==1">
                <button class="retry-button" @click="retry()">
                    <div class="icon-util retry retry-button-position"></div>{{$t('language.common.retry')}}
                </button>
            </div>
            <div class="failed-files-contens">
                <div class="failed_empty_tip" v-if="unfinishData.length<1" v-html="$t('language.common.failedEmptyTip')"></div>
                <div class="all-failed-box">
                    <table border="0" cellpadding="0" cellspacing="0" style="width:100%;">
                        <thead>
                            <tr class="retry-th">
                                <th width='21.5%' fixed="true">
                                    <div style="float:left;top:10Px;" class="icon-util failed-retry-position" v-if="transferType==1" :class="selectedArr.length!=0&&(selectedArr.length == (unfinishData.length-retryedArr.length))?'check-small':'nocheck-small-blue'" @click="checkedAll()"></div>
                                    <div style="width:10Px;height:10Px;float:left"  v-if="transferType==2"></div>
                                    <div v-if="!selectedArr.length" style="float:left;">{{$t('language.common.name')}}</div>
                                    <div v-if="selectedArr.length" class="selected-style" :title="selectedArr.length+$t('language.common.itemsSelected')">{{selectedArr.length}} {{$t('language.common.itemsSelected')}}</div>
                                </th>
                                <th width='13%' fixed="true">{{$t('language.common.size')}}</th>
                                <th width='26.5%' fixed="true">{{$t('language.common.sourceDir')}}</th>
                                <th width='27%' fixed="true">{{$t('language.common.cause')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="failed-retry-tr" v-for="(item, index) in unfinishData" :key="index">
                                <td width='25%' style="float:left;">
                                    <div v-if="!item.retryed">
                                        <div class="icon-util failed-retry-position" style="float:left;margin-right:17px;/*no*/" v-if="transferType==1" :class="selectedArr.includes(item)?'check-small':'nocheck-small-blue'" @click="selectItem(item)"></div>
                                         <div style="width:10Px;height:10Px;float:left"  v-if="transferType==2"></div>
                                     </div>
                                    <div v-if="item.retryed">
                                        <div class="icon-util eye view-logs-eye failed-retry-position" @click="toAimRootCatalog()" title="View"></div>
                                    </div>
                                    <div class="failed-files-one" v-if="item.filename" :title="item.filename"  >{{item.filename}}</div>
                                    <div class="failed-files-one" v-else :title="item.name"  >{{item.name}}</div>
                                </td>
                                <td width='15%' v-if="item.filesize ||item.filesize==0"  style="float:left;">{{item.filesize|formatLogByte}}</td>
                                <td width='15%' v-else  style="float:left;">{{item.size|formatLogByte}}</td>
                                <td width='30%' class="item-dire" v-if="item.fromItem.driveType!=='Shares'" @click="tofailedCategroy(item.fromItem)" :title="item.fromItem.nodes|getCatalog|getCatalogTitle">{{item.fromItem.nodes|getCatalog}}</td>
                                <td width='30%' class="item-dire" v-else @click="toSharelicLink(item.fromItem)" :title="item.fromItem.nodes|getCatalogShare|getCatalogTitle">{{item.fromItem.nodes|getCatalogShare}}</td>
                                <td width='30%' style="float:left;">
                                    <div class="failed-files-two" v-if="item.cause" :title="item.cause|getCauseReason">{{item.cause|getCauseReason}}</div>
                                    <div class="failed-files-two" v-else :title="item.exception|getCauseReason">{{item.exception|getCauseReason}}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div v-if="unfinishData.length >= 1000" style="position:relative;top:20px;fontSize:14px;">{{$t('language.cloudBackup.maxLogs')}}</div>
            <div class="retry-footer">
                <a href="https://www.multcloud.com/help/limitations.html" target="_blank" class="retry-limits">{{$t('language.popup.limits')}}</a>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
export default {
    data: function () {
        return {
            retryFailedShow: false,
            retryPromptShow: true,
            selectedArr: [],
            unfinishData: [],
            transferType: '',
            retryedArr: [],
            currentIndex: -1,
            retryFrom: [],
            retryToArr: [],
            retryAllData: []
        };
    },
    computed: {
        retryItemsNew() {
            return Object.assign([], this.$store.state.retryItems);
        }
    },
    methods: {
        cleanList() {
            this.unfinishData = null;
        },
        //选中一条数据
        selectItem(item) {
            this.retryPromptShow = false;
            if (this.selectedArr.includes(item)) {
                this.selectedArr = this.selectedArr.filter(function (ele) {
                    return ele != item;
                });
            } else {
                this.selectedArr.push(item);
            }
        },
        //选中所有数据
        checkedAll() {
            if (this.selectedArr.length == (this.unfinishData.length - this.retryedArr.length)) {
                this.selectedArr = [];
            } else {
                this.selectedArr = [];
                for (let i = 0; i < this.unfinishData.length; i++) {
                    if (!this.unfinishData[i].retryed) {
                        this.selectedArr.push(this.unfinishData[i]);
                    }
                }
            }
        },
        //重试
        retry() {
            let that = this;
            let user = commonUtils.getUser();
            let remove;
            //流量不足弹窗提醒
             let usedTraffic = user.usedBytes;
            //  if(user.vip&&user.payLevel>1){
            //      usedTraffic = user.payUsedTraffic;
            //     }
            if (user.totalBytes != -1 && usedTraffic >= user.totalBytes) {
                this.$parent.$refs.upgradeDialog.upgradeShow = true;
                this.$parent.$refs.upgradeDialog.reset();
                this.$parent.$refs.upgradeDialog.trafficShow = true;
                return false;
            }
            let options;
            this.currentIndex = -1;
            let retryData;
            that.$store.state.cancelAllFlag = false;
            let retryAllData = Object.assign([], this.selectedArr);//获取重试任务总长度
            let snapData= Object.assign([], this.$store.state.retryItems);//获取临时任务待处理列表任务总长度
            let uploadArr=Object.assign([], this.$store.state.uploadArr);//获取此时上传任务总长度
            if (retryAllData.length) {
                let allLength=snapData.length+uploadArr.length+retryAllData.length;//将所有要运行的临时任务求和
                if(allLength>200){//超过两百给出提示，并且只添加前200个任务
                    this.$toast({
                        text: this.$t('language.cloudExploer.simultaneous'),
                        type: 'fail',
                        idValue: "allBox"
                    });
                   
                      let index = allLength - 200;
                      retryAllData.splice(retryAllData.length - index,retryAllData.length + 1);
                      if(!retryAllData.length){
                          return;
                      }
                }
                this.retryAllData = retryAllData;
                this.selectedArr = [];
                let toItem = this.packageFromToItem(retryAllData[0].toItem);
                let fromItemArr=[];
                for (let i = 0; i <= retryAllData.length - 1; i++) {
                    retryAllData[i].retryed = true;
                    //对重传数据的nodes格式进行封装为需要的格式
                    $.each(retryAllData[i].fromItem.nodes, function (index, item) {
                        if (item.fileName) {
                            item.filename = item.fileName;
                        }
                        delete item.cloudType;
                        delete item.tokenId;
                        delete item.fileName;
                    });
                    $.each(retryAllData[i].toItem.nodes, function (index, item2) {
                        if (item2.fileName) {
                            item2.filename = item2.fileName;
                        }
                        delete item2.cloudType;
                        delete item2.tokenId;
                        delete item2.fileName;
                    });
                    let fromItem = this.packageFromToItem(retryAllData[i].fromItem);
                    if(fromItem.driveType=='Shares'){
                        fromItem.way="share";
                    }
                    let filesize = retryAllData[i].filesize;
                    fromItem.filesize = filesize;
                    if (fromItem.nodes[0].fileId != retryAllData[i].fileid) {
                        let nodeItem = {
                            fileId: retryAllData[i].fileid,
                            filename: retryAllData[i].filename
                        }
                        let nodesOld = fromItem.nodes;
                        let nodesNew = [];
                        nodesNew.push(nodeItem);
                        $.each(nodesOld, function (index, nodeOld) {
                            nodesNew.push(nodeOld);
                        });
                        delete fromItem.nodes;
                        fromItem.nodes = nodesNew;
                        fromItem.fileId = fromItem.nodes[0].fileId;
                        fromItem.filename = fromItem.nodes[0].filename;
                        fromItem.isDir = false;
                    }
                    fromItemArr.push(fromItem);
                    if (retryAllData[i].options) {
                        options = retryAllData[i].options;
                        options.isChar = 1;
                    } else {
                        options = {
                            isChar: 1
                        }
                    }
                    if(options.isRemove==1){
                        remove=true;
                    }
                }
                //如果源文件是文件夹重传的文件直接到目录
                if(retryAllData[0].fromItem&&retryAllData[0].fromItem.isDir){
                toItem.fileId = retryAllData[0].desid;
                toItem.filename = retryAllData[0].desname;
                toItem.nodes.unshift({
                     fileId:toItem.fileId,
                     filename:toItem.filename
                });
                }
                commonUtils.judgeNewDataFlag(that);
                commonUtils.packageDetailData(fromItemArr,[toItem],remove);//把数据放在临时任务待执行弹窗          
                //显示临时任务列表弹窗
                that.$store.state.snapTaskShow = true;
                let addData = new taskTransferUtils.addTaskData(user.id, 4, fromItemArr[0].filename, fromItemArr, [toItem], options, null);
                that.Utils.doTasksRequest('add', addData).then(res => {
                    if (res.status == 200) {
                        that.$store.state.cancelAllFlag = true;//清空按钮置为显示
                        commonUtils.letFlagTrue(that);
                        commonUtils.packageHaveDataDetail(res.tasks);//把返回的taskId给待处理任务
                    }else if(res.status == 400&&res.reason=='permissionFail'){
                        commonUtils.removeDataDetail(addData);
                        that.$toast({
                            text: that.$t('language.exception.notPermission'),
                            type: 'fail',
                            idValue: "rightBodyList",
                            duration:5000
                        });
                    } 
                });
            } else {
                this.$toast({
                    text: this.$t('language.common.selectNull'),
                    type: 'fail',
                    idValue: "rightBodyList"
                });
            }
        },
        deletePasteTask(item, callback) {
            let that = this;
            if (item.detail) {
                let pasteTask = {
                    ud: commonUtils.getUser().id,
                    type: 4,
                    wd: item.detail.taskId
                }
                that.Utils.doTasksRequest('remove_completed_task', pasteTask).then(response => {
                    callback(response);
                });
            }
        },
        tofailedCategroy(fromItem) {
            this.$parent.toSourceCatalog(fromItem);
        },
        packageFromToItem(fromToItem) {
            let item;
            fromToItem.fileId = fromToItem.id;
            fromToItem.filename = fromToItem.name;
            delete fromToItem.id;
            delete fromToItem.name;
            fromToItem.pid = fromToItem.nodes[fromToItem.nodes.length - 1].fileId;
            if (fromToItem.isDir) {
                item = new taskTransferUtils.DirItem(fromToItem.driveType, fromToItem.driveId, fromToItem.pid, fromToItem.fileId, fromToItem.filename, fromToItem.isDir, fromToItem.nodes);
            } else {
                item = new taskTransferUtils.FileItem(fromToItem.driveType, fromToItem.driveId, fromToItem.pid, fromToItem.fileId, fromToItem.filename, fromToItem.isDir, fromToItem.filesize, fromToItem.nodes);
            }
            return item;
        },
        toAimRootCatalog() {
            this.closePage();
            this.$parent.$refs.viewLogsDialog.toAimRootCatalog();
        },
        closePage() {
            this.retryFailedShow = false;
            $.each(this.unfinishData, function (i, item) {
                item.retryed = false;
            });
        },
        //点击分享链接
        toSharelicLink (item) {
            if(item.sharePath){
                this.$store.commit("setSharePath", JSON.parse(item.sharePath));
            }
            let link = item.shareUrl;
            window.open(link);
        },
    }
};
</script>

<style>
#retryFailed {
    width: 680px;
    /*no*/
    height: 510px;
    /*no*/
}

.retry-body {
    width: 100%;
    height: 465px;
    /*no*/
    box-sizing: border-box;
    padding: 20px;
    /*no*/
    font-size: 16px;
    /*no*/
}

.retry-buttons {
    width: 100%;
    height: 30px;
    /*no*/
}

.retry-button {
    height: 30px;
    /*no*/
    float: left;
}

.retry-broom-position {
    float: right;
    position: relative;
    top: 2px;
    /*no*/
}

.view-logs-eye {
    float: left;
    margin-right: 17px;
    /*no*/
    cursor: pointer;
}

.retry-broom-position:hover:after {
    content: attr(data-title);
    position: absolute;
    border: #8a96e3 solid 1px;
    /*no*/
    background: #fff;
    font-size: 13px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    padding: 2px;
    /*no*/
    border-radius: 2px;
    /*no*/
    z-index: 200;
    top: 20px;
    /*no*/
    left: 15px;
    /*no*/
    width: 60px;
    /*no*/
    height: 20px;
    /*no*/
    line-height: 20px;
    /*no*/
    white-space: nowrap;
}

.failed-files-contens {
    width: 100%;
    height: 300px;
    /*no*/
    box-sizing: border-box;
    margin-top: 10px;
    /*no*/
    border: 1px solid #F0F0FB;
    /*no*/
    position: relative;
}

.failed_empty_tip {
    position: absolute;
    top: 50px; /*no*/
    left: 0px; /*no*/
}

.retry-th {
    width: 100%;
    height: 35px;
    /*no*/
    line-height: 35px;
    /*no*/
    font-size: 14px;
    /*no*/
    color: #a3adbd;
    margin: 0;
    background: #f2f7fe;
}

.all-failed-box table tr th {
    font-weight: 300;
    text-align: left;
    table-layout: fixed;
}

.all-failed-box table td {
    text-align: left;
    table-layout: fixed;
}

.retry-limits {
    font-size: 14px;
    /*no*/
    color: #2e79f6;
    float: left;
    text-decoration: none;
    line-height: 50px;
    /*no*/
}

.retry-limits:hover,

.retry-button-position {
    float: left;
}

.retry-footer {
    position: absolute;
    bottom: 0;
}

.retry-prompt {
    font-size: 14px;
    /*no*/
    color: #FF1B46;
    position: relative;
    top: 30px;
    /*no*/
}

.failed-retry-tr td {
    height: 20px;/*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/popup/task_list_popups/view_failed_files_popups.vue